<template>
  <div class="task_hall_detail">
    <!-- 详情内容 -->
    <div class="detail_content">
      <!-- 左边图片 -->
      <div class="detail_content_img">
        <img v-lazy="task_hall_detail.coverPath" alt />
      </div>
      <!-- 右边内容 -->
      <div class="detail_content_desc">
        <div class="detail_des_title">{{ task_hall_detail.name }}</div>
        <p>任务酬金：</p>
        <div class="detail_desc_money">
          <span>￥</span>
          {{ task_hall_detail.money }}
        </div>
        <div class="detail_desc_progress">
          <!-- 进度条 -->
          <el-steps :space="300" :active="num" finish-status="success">
            <el-step title="征集中" class="going"></el-step>
            <el-step title="征集结束"></el-step>
            <el-step title="筛选中"></el-step>
            <el-step title="生产中"></el-step>
            <el-step title="销售中"></el-step>
          </el-steps>
        </div>
        <div class="detail_desc_msg">
          <div class="msg_item">
            <div class="msg_item_top">{{ task_hall_detail.target_population_name }}</div>
            <div class="msg_item_bottom">目标人群</div>
          </div>
          <div class="msg_item">
            <div class="msg_item_top">{{ task_hall_detail.all_date }}天</div>
            <div class="msg_item_bottom">任务周期</div>
          </div>
          <div class="msg_item">
            <div class="msg_item_top">{{ task_hall_detail.surplus_date }}天</div>
            <div class="msg_item_bottom">剩余时间</div>
          </div>
          <div class="msg_item">
            <div class="msg_item_top">{{ task_hall_detail.assign_submit }}</div>
            <div class="msg_item_bottom">报名人数</div>
          </div>
        </div>
        <div class="btn">
          <el-button
            class="btn_enroll"
            @click="apply"
            v-if="!task_hall_detail.is_submit && progressStatus"
          >报名投稿</el-button>
          <el-button
            class="btn_enroll2"
            v-if="!task_hall_detail.is_submit && !progressStatus"
            disabled
          >报名投稿</el-button>
          <el-button class="btn_enroll" v-if="task_hall_detail.is_submit" @click="checkOpus">查看作品</el-button>
          <div class="collection">
            <createCollection v-if="!task_hall_detail.isCollection" :create_obj="task_hall_detail"></createCollection>
            <cancelCollection v-else :cancel_obj="task_hall_detail"></cancelCollection>
          </div>
        </div>
      </div>
    </div>
    <!-- 下边内容描述 -->
    <div class="detail_desc">
      <div class="detail_desc_left">
        <!-- 任务详情 -->
        <div class="detail_task">
          <div class="item_title">
            任务详情
            <span @click="toStandard">交付标准</span>
          </div>
          <div
            class="detail_task_content ck-text"
            ref="detail_task_content"
            v-html="task_hall_detail.content"
          ></div>
        </div>
        <!-- 交付标准 -->
        <div class="pay_standard" id="header" ref="pay_standard">
          <div class="pay_standard_title">交付标准</div>
          <div class="pay_standard_content">
            <img src="@/assets/img/task/pay.png" alt v-if="task_hall_detail.is_default_delivery" />
            <template v-else>{{task_hall_detail.delivery_criterion}}</template>
          </div>
        </div>
        <!-- 已报名设计师 -->
        <div class="registered_designer">
          <div class="registered_designer_title">已报名设计师({{ layerpageinfo.total }}人)</div>
          <div class="registered_designer_content">
            <ul v-for="item in design_list" :key="item.id">
              <li>
                <img v-lazy="item.headPath" />
                <div v-if="item.nick_name">{{ item.nick_name }}</div>
                <div v-else>暂无</div>
                <div v-if="item.profession_name">{{ item.profession_name }}</div>
                <div v-else>暂无</div>
                <div v-if="item.city_name">{{ item.city_name }}</div>
                <div v-else>暂无</div>
                <div>作品数：{{ item.opus_count }}</div>
                <div v-if="item.create_date">报名时间：{{ item.create_date }}</div>
                <div v-else>暂无</div>
              </li>
            </ul>
          </div>
          <!-- 分页 -->
          <div class="page_box">
            <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
          </div>
        </div>
      </div>
      <div class="detail_desc_right">
        <!-- 任务发起方 -->
        <div class="task_initiator">
          <div class="item_title">任务发起方</div>
          <div class="task_initiator_content" v-if="task_hall_detail.brand">
            <div
              class="initiator_content_left"
              @click="go('brand',brand_detail.id)"
              style="cursor:pointer;"
            >
              <img v-lazy="brand_detail.coverPath" alt />
            </div>
            <div class="initiator_content_right">
              <div class="initiator_content_name">{{ brand_detail.name }}</div>
              <div class="initiator_content_desc">{{ brand_detail.title }}</div>
            </div>
          </div>
          <div class="task_initiator_content" v-else>
            <div class="initiator_content_left">
              <img v-lazy alt />
            </div>
            <div class="initiator_content_right">
              <div class="anonymity_brand">匿名品牌商</div>
            </div>
          </div>
        </div>
        <!-- 参考素材 -->
        <div class="reference_material">
          <div class="reference_material_title">参考素材</div>
          <ul v-if="attachment_list.length">
            <li
              class="reference_material_content"
              v-for="(item,index) in attachment_list"
              :key="index"
            >
              <div class="material_content_filetype">{{item.attachmentType.toLocaleUpperCase()}}</div>
              <a
                target="_blank"
                class="material_content_filename"
                :download="item.attachmentName"
                :href="item.attachmentPath"
              >{{ item.attachmentName }}</a>
            </li>
          </ul>
        </div>
        <!-- 相关推荐 -->
        <div class="related_recommendation">
          <div class="item_title">相关推荐</div>
          <ul>
            <li
              class="related_recommendation_content"
              v-for="item in recommend_list"
              :key="item.id"
            >
              <router-link :to="`/task_hall_detail?id=${item.id}`" target="_blank">
                <div class="recommendation_content_left">
                  <img v-lazy="item.coverPath" alt />
                </div>
                <div class="recommendation_content_right">
                  <div class="recommendation_name">{{ item.name }}</div>
                  <div class="recommendation_price">
                    <span>任务酬金：</span>
                    ￥{{ item.money }}
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
import createCollection from "@/components/collectionTask/createCollection";
import cancelCollection from "@/components/collectionTask/cancelCollection";

export default {
  components: {
    myPage,
    createCollection,
    cancelCollection
  },
  data() {
    return {
      activeName: "first",
      task_hall_detail: {}, //设计任务详情
      layerpageinfo: {
        pageSize: 10,
        pageNo: 0,
        total: 0
      },
      num: 0, //任务进程
      recommend_list: [], //推荐列表
      brandID: "", //品牌商
      brand_detail: {}, //品牌商详情
      material_name: [], //参考素材名称
      design_list: [], //设计师作品
      identity: "", //用户身份
      attachment_list: [], //参考素材列表
      progressStatus: true, //是否可报名
      opus_id: "", //作品id
      designer_code: "" //设计师code
    };
  },
  created() {
    // 获取设计任务列表
    this.getFrontAssigns();
    // 推荐列表
    this.getRecommend();
    // 已报名设计师
    this.getAssignSubmitDesigners();
    if (this.$store.state.info) {
      this.getFrontDesigners(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("getFrontDesigners");
    }
  },
  computed: {
    // 个人信息
    info() {
      return this.$store.state.info;
    },
    // 登录弹框
    loginVisible() {
      return this.$store.state.isLoginDialog;
    }
  },
  methods: {
    // 报名投稿
    apply() {
      // 未登录状态下
      if (!this.$store.state.info) {
        this.$store.dispatch("setIsLoginDialog", true);
        return;
      }
      // 不是设计师状态下
      if (this.isDesigner()) return;
      this.$router.push({
        name: "task_hall_opus_list",
        query: {
          task_id: this.task_hall_detail.id
        }
      });
    },
    // 查看作品
    checkOpus() {
      this.$router.push({
        name: "task_hall_opus_detail",
        query: {
          id: this.task_hall_detail.id
        }
      });
    },
    // 非设计师
    isDesigner() {
      if (this.identity !== "IdentityCertifieStatussuccess") {
        this.$confirm("您还不是设计师，是否前往认证?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$router.push({
            name: "join",
            query: {
              code: this.designer_code
            }
          });
        });
        return true;
      }
    },
    // 任务状态
    taskStatus() {
      // 任务状态
      let status = this.task_hall_detail.status;
      if (
        status !== "AssignStatusCollection" ||
        this.task_hall_detail.status_name === "未开始"
      ) {
        this.progressStatus = false;
      }
    },
    // 获取设计师身份
    getFrontDesigners() {
      this.api
        .getFrontDesigners({
          user_id: this.$store.state.info.id
        })
        .then(res => {
          if (res.error.err_code !== 0) return;
          this.identity = res.obj.list.length ? res.obj.list[0].status : "";
          this.designer_code = res.obj.list.length ? res.obj.list[0].code : "";
        });
    },
    // 获取任务详情
    getFrontAssigns() {
      this.api
        .getFrontAssigns({
          id: this.$route.query.id
        })
        .then(res => {
          if (res.error.err_code != 0) return;
          let list = res.obj.list[0] || {};
          this.task_hall_detail = list;
          // 任务发起方
          this.brandID = list.brand;
          // 参考素材
          this.attachment();
          // 获取品牌商
          this.getBrands();
          // 任务进度
          this.progress();
          // 任务状态
          this.taskStatus();
        });
    },
    // 参考素材
    attachment() {
      let list = this.task_hall_detail;
      let pathArr = [];//链接集合
      let nameArr = [];//名称集合
      let Arr =[];//json
      if(list.attachmentPaths.length){
          pathArr = list.attachmentPaths.split("|") || [];
          nameArr = list.attachmentNames.split("|") || [];
      }
      
      for (let i = 0; i < pathArr.length; i++) {
          Arr.push({
            attachmentPath:pathArr[i],
            attachmentName:nameArr[i],
            attachmentType:nameArr[i].split('.')[1]
          })
      }
        // 参考素材数组
        this.attachment_list = Arr;
    },
    // 任务进度
    progress() {
      let status = this.task_hall_detail.status;
      // 开始征集时间
      let start_date = new Date(
        this.task_hall_detail.start_collect_date
      ).getTime();
      // 当前时间
      let now_date = new Date().getTime();

      if (
        status === "AssignStatusCollection" &&
        this.task_hall_detail.status_name === "未开始"
      ) {
        // 征集未开始
        this.num = 0;
      } else if (status === "AssignStatusCollection") {
        // 征集中
        this.num = 1;
      } else if (status === "AssignStatusCollectionEnd") {
        // 征集结束
        this.num = 2;
      } else if (status === "AssignStatusScreen") {
        // 筛选中
        this.num = 3;
      } else if (status === "AssignStatusProduction") {
        // 生产中
        this.num = 4;
      } else if (status === "AssignStatusSale") {
        // 销售中
        this.num = 5;
      }
    },
    // 品牌商
    getBrands() {
      console.log(this.brandID);
      this.api
        .getBrands({
          id: this.brandID
        })
        .then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.brand_detail = list.length ? list[0] : {};
        });
    },
    // 相关推荐
    getRecommend() {
      this.api
        .getRecommend({
          pageSize: 4
        })
        .then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.recommend_list = list.length ? list : [];
        });
    },
    // 点击收藏或者取消收藏
    // collectionDesign(){
    //     if(!this.task_hall_detail.isCollection){
    //         // 收藏
    //         this.createFrontCollection()
    //     }else{
    //         // 取消收藏
    //         this.deleteFrontCollection()
    //     }

    // },
    // 收藏

    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
    },
    //监听个人信息
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    // 获取已报名设计师
    getAssignSubmitDesigners() {
      this.api
        .getAssignSubmitDesigners({
          assign: this.$route.query.id
        })
        .then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.design_list = list.length ? list : [];
          this.layerpageinfo.total = res.obj.totalSize;
        });
    },
    // 交付标准跳转
    toStandard() {
      // 任务详情高度
      let task_detail = this.$refs.detail_task_content.offsetHeight;
      console.log(task_detail);
      document.documentElement.scrollTop = task_detail + 520;
    },
    // 跳转品牌详情
    go(name, id) {
      this.$router.push({ name: name, query: { id: id } });
    }
  }
};
</script>

<style lang="scss">
@import url("../../peronsal_center/index.scss");
.task_hall_detail {
  margin: 30px auto;
  width: 1200px;
  // 详情内容
  .detail_content {
    padding: 20px 5px 20px 20px;
    // background-color: aqua;
    display: flex;
    background-color: $bg-white;
    // 左边图片
    .detail_content_img {
      width: 752px;
      height: 377px;
      margin-right: 20px;
      display: flex;
      overflow: hidden;
      justify-content: center;
      align-items: center;
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
    // 右边内容
    .detail_content_desc {
      overflow: hidden;
      .el-step__title {
        margin-left: -16px;
      }
      .going {
        .el-step__main {
          .el-step__title {
            margin-left: 0;
          }
        }
      }
      .el-step__head.is-process {
        position: relative;
        width: 93px;
        .el-step__line {
          height: 7px;
          margin-top: -5px;
        }
        .el-step__icon {
          width: 18px;
          height: 18px;
          .el-step__icon-inner {
            display: none;
          }
        }
      }
      .el-step__head.is-process::before {
        display: block;
        content: "";
        width: 93px;
        height: 7px;
        background-color: rgb(192, 196, 204);
        position: absolute;
        top: 6px;
        left: -93px;
      }
      .el-step__head.is-success {
        width: 93px;
        .el-step__line {
          .el-step__line-inner {
            width: 93px !important;
            height: 7px;
            margin-top: -5px;
            background-color: rgb(103, 194, 58);
          }
        }
        .el-step__icon {
          width: 18px;
          height: 18px;
          .el-step__icon-inner is-status {
            display: block;
          }
        }
      }
      .el-step__head.is-wait {
        width: 93px;
        .el-step__line {
          height: 7px;
          margin-top: -5px;
        }
        .el-step__icon {
          width: 18px;
          height: 18px;
          .el-step__icon-inner {
            display: none;
            font-size: 12px;
          }
        }
      }
      .detail_des_title {
        line-height: 36px;
        font-size: 26px;
        color: $font-black;
      }
      p {
        line-height: 42px;
        font-size: 14px;
        color: $font-gary;
      }
      .detail_desc_money {
        line-height: 34px;
        font-size: 30px;
        color: rgba(212, 40, 45, 1);
        span {
          font-size: 20px;
        }
      }
      // 进度条
      .detail_desc_progress {
        margin-top: 25px;
      }
      .detail_desc_msg {
        width: 388px;
        height: 70px;
        background: rgba(245, 245, 245, 1);
        // padding: 15px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-top: 20px;
        .msg_item {
          width: 97px;
          border-right: 1px solid #e2e2e2;
          text-align: center;
          .msg_item_top {
            height: 25px;
            line-height: 25px;
            font-size: 16px;
            color: $font-black;
          }
          .msg_item_bottom {
            line-height: 25px;
            font-size: 12px;
            color: $font-gary;
          }
        }
        .msg_item:nth-child(4) {
          border-right: none;
        }
      }
      .btn {
        display: flex;
        margin-top: 55px;
        .btn_enroll {
          width: 188px;
          height: 42px;
          background: rgba(17, 17, 17, 1);
          color: $bg-white;
        }
        .btn_enroll2 {
          width: 188px;
          height: 42px;
          background: #444444;
          color: $bg-white;
        }
        .collection {
          margin-left: 10px;
        }
        .collected {
          border: 1px solid #ff6d00;
          color: #ff6d00;
          background-color: #fff;
        }
      }
    }
  }
  .detail_desc {
    display: flex;
    margin-top: 20px;
    .detail_desc_left {
      // 任务详情
      .detail_task {
        width: 830px;
        background-color: $bg-white;
        padding: 10px 20px 10px;
        box-sizing: border-box;
        margin-right: 20px;
        .item_title {
          position: relative;
          span {
            margin-left: 50px;
            cursor: pointer;
          }
        }
        .item_title:before {
          content: "";
          display: block;
          width: 32px;
          height: 3px;
          background-color: #111111;
          position: absolute;
          top: 55px;
          left: 12px;
        }
      }
      // 交付标准
      .pay_standard {
        width: 830px;
        padding:20px;
        margin-top: 10px;
        background-color: #fff;
        box-sizing: border-box;
        text-indent: 24px;
        .pay_standard_title {
          line-height: 20px;
          margin-left: 10px;
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          position: relative;
        }
        .pay_standard_title::before {
          content: "";
          display: block;
          width: 3px;
          height: 16px;
          background-color: #111111;
          position: absolute;
          top: 2px;
          left: -10px;
        }
        .pay_standard_content {
          padding-top: 20px;
          font-size: 14px;
          color: rgba(102, 102, 102, 1);
          line-height: 21px;
        }
      }
      // 已报名设计师
      .registered_designer {
        width: 830px;
        padding: 20px 20px 1px;
        margin-top: 10px;
        background-color: #fff;
        box-sizing: border-box;
        .registered_designer_title {
          line-height: 20px;
          margin-left: 10px;
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          position: relative;
        }
        .registered_designer_title::before {
          display: block;
          content: "";
          width: 3px;
          height: 16px;
          background-color: #111111;
          position: absolute;
          top: 2px;
          left: -10px;
        }
        .registered_designer_content {
          margin-top: 30px;
          ul {
            li {
              display: flex;
              align-items: center;
              margin-bottom: 26px;
              img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
              }
              div {
                width: 135px;
                line-height: 20px;
                border-right: 1px solid rgba(226, 226, 226, 1);
                padding: 0 29px;
                box-sizing: border-box;
                text-align: center;
                font-size: 14px;
                color: rgba(102, 102, 102, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: normal;
              }
              div:nth-child(6) {
                border-right: none;
                width: 200px;
              }
              div:nth-child(2) {
                padding: 0 29px 0;
              }
            }
          }
        }
        .page_box {
          margin-left: -200px;
        }
      }
    }
    .detail_desc_right {
      // 任务发起方
      .task_initiator {
        width: 350px;
        background-color: $bg-white;
        padding: 0 20px;
        box-sizing: border-box;
        .task_initiator_content {
          padding: 35px 0;
          box-sizing: border-box;
          display: flex;
          .initiator_content_left {
            img {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              border: 1px solid #eeeeee;
            }
          }
          .initiator_content_right {
            padding: 5px 20px;
            box-sizing: border-box;
            .initiator_content_name {
              line-height: 22px;
              font-size: 16px;
              color: rgba(51, 51, 51, 1);
            }
            .initiator_content_desc {
              line-height: 30px;
              font-size: 14px;
              color: rgba(153, 153, 153, 1);
            }
            .anonymity_brand {
              line-height: 60px;
              font-size: 14px;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
      }
      // 参考素材
      .reference_material {
        width: 350px;
        background-color: $bg-white;
        padding: 0 20px;
        box-sizing: border-box;
        margin-top: 20px;
        .reference_material_title {
          line-height: 57px;
          align-items: center;
          border-bottom: 1px solid rgba(238, 238, 238, 1);
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
        }
        .reference_material_content {
          display: flex;
          padding: 25px 0;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(238, 238, 238, 1);
          cursor: pointer;
          .material_content_filetype {
            width: 36px;
            text-align: center;
            height: 17px;
            border: 1px solid rgba(213, 213, 213, 1);
            margin-right: 10px;
            margin-top: -2px;
            font-size: 12px;
            color: #999999;
            padding: 2px;
            box-sizing: border-box;
          }
          .material_content_filename {
            color: #333333;
            line-height: 21px;
            margin-top: -3px;
          }
          .material_content_filename:hover {
            color: #117eff;
          }
        }
        .reference_material_content:last-of-type {
          border-bottom: none;
        }
      }
      // 相关推荐
      .related_recommendation {
        width: 350px;
        background-color: $bg-white;
        padding: 0 20px;
        box-sizing: border-box;
        margin-top: 20px;
        ul {
          padding: 30px 0 1px;
          box-sizing: border-box;
          .related_recommendation_content {
            a {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              cursor: pointer;
              .recommendation_content_left {
                margin-right: 10px;
                img {
                  width: 110px;
                  height: 82px;
                  // margin-right: 10px;
                }
              }
              .recommendation_content_right {
                padding: 5px 0;
                .recommendation_name {
                  line-height: 22px;
                  font-size: 14px;
                  color: rgba(51, 51, 51, 1);
                  width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-wrap: normal;
                  // height: 22px;
                }
                .recommendation_price {
                  line-height: 35px;
                  color: rgba(212, 40, 45, 1);
                  margin-top: 15px;
                  span {
                    color: rgba(153, 153, 153, 1);
                  }
                }
              }
            }
          }
          .related_recommendation_content:last-of-type {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>